import PropTypes from 'prop-types';
import { createContext, useCallback, useContext, useEffect, useMemo, useState } from 'react';

const LayoutContext = createContext();

export const LayoutProvider = ({
  children,
  onTrocarLoja = null,
  temMultiplasLojas = false,
  nomeLojaAtiva = '',
}) => {
  const [isMRV, setIsMRV] = useState(true);

  // Funçao para atualizar o título da página
  const updatePageTitle = useCallback(isMRV => {
    document.title = `Simulador ${isMRV ? 'MRV' : 'Sensia'}`;
  }, []);

  // Funçao para atualizar o favicon
  const updateFavicon = useCallback(isMRV => {
    const favicon = document.querySelector('link[rel="shortcut icon"]');
    if (favicon) {
      favicon.href = isMRV ? 'img/mrv-icon.ico' : 'img/sensia-icon.ico';
    }
  }, []);

  // Funçao para obter o tema de acordo com a empresa
  const getCompanyTheme = useCallback(isMRV => {
    const mrvTheme = {
      '--primary': '#0a8754',
      '--primary-dark': '#076e43',
      '--secondary': '#f5a623',
    };

    const sensiaTheme = {
      '--primary': '#23403D',
      '--primary-dark': '#1A2E2C',
      '--secondary': '#D6A461',
    };

    return isMRV ? mrvTheme : sensiaTheme;
  }, []);

  // Funçao para aplicar o tema CSS
  const applyTheme = useCallback(theme => {
    Object.entries(theme).forEach(([property, value]) => {
      document.documentElement.style.setProperty(property, value);
    });
  }, []);

  // Effect para atualizar tema quando a empresa e alterada
  useEffect(() => {
    updatePageTitle(isMRV);
    updateFavicon(isMRV);
    const theme = getCompanyTheme(isMRV);
    applyTheme(theme);
  }, [isMRV, updatePageTitle, updateFavicon, getCompanyTheme, applyTheme]);

  const handleCompanyToggle = useCallback(e => {
    const newValue = e.target.checked;
    setIsMRV(newValue);
  }, []);

  const value = useMemo(
    () => ({
      isMRV,
      handleCompanyToggle,
      onTrocarLoja,
      temMultiplasLojas,
      nomeLojaAtiva,
    }),
    [isMRV, handleCompanyToggle, onTrocarLoja, temMultiplasLojas, nomeLojaAtiva]
  );

  return <LayoutContext.Provider value={value}>{children}</LayoutContext.Provider>;
};

LayoutProvider.propTypes = {
  children: PropTypes.node.isRequired,
  onTrocarLoja: PropTypes.func,
  temMultiplasLojas: PropTypes.bool,
  nomeLojaAtiva: PropTypes.string,
};

export const useLayoutContext = () => {
  const context = useContext(LayoutContext);
  if (!context) {
    throw new Error('useLayoutContext deve ser usado dentro de um LayoutProvider');
  }
  return context;
};
